.truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    // flex: 1 1 auto;
}
